import axios from "axios";

const setAuthToken = (token) => {
  axios.defaults.headers.common.Accept = "application/json";
  if (axios.defaults.headers?.common) {
    delete axios.defaults.headers.common.Authorization;
  }

  if (typeof token === "string" && token.trim()) {
    const raw = token.trim().replace(/^Bearer\s+/i, "");
    axios.defaults.headers.common = {
      ...(axios.defaults.headers.common || {}),
      Authorization: `Bearer ${raw}`,
    };
  }
};

export default setAuthToken;
